import { Description } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

import { CateCity, useCities } from '@/context/Cities'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { SuggestedCriteria } from '@/lib/api-gluglu-auth'
import { ellipsis, pointShapeDivider } from '@/shared-styles/styles.css'
import { getBudgetFromCriteria, getRoomsMinLabel } from '@/utils/criteria-utils'

import { criteriaListCities, criteriaListElement } from './index.css'

type Props = {
  criteria: SuggestedCriteria
}

const getCityNameByGeoSlug = (geoSlugs: string[], cities: CateCity[]) => {
  const citySlugWithoutZone = geoSlugs.map((item) => item.split('/').slice(0, 2).join('/'))
  return cities.filter((city) => citySlugWithoutZone?.includes(city.slug)).map((city) => city.translatedCityName)
}

export const CriteriaList: React.FC<Props> = ({ criteria }) => {
  const cities = useCities()
  const { lang, t } = useTranslation()

  const criteriaCities = getCityNameByGeoSlug(criteria.geo_slugs, cities.list)
  const dividerStyle = cn(
    pointShapeDivider,
    sprinkles({ display: { desktop: 'inline-block', mobile: 'none' }, flexShrink: 0 })
  )

  return (
    <>
      <Description color="deepGreen600">{t('suggested:Suggested_SearchResume_Intro')}</Description>
      <Description strong className={sprinkles({ display: 'flex' })} color="deepGreen600">
        <span className={cn(criteriaListElement, criteriaListCities, ellipsis)}>{criteriaCities.join(', ')}</span>
        {criteriaCities[0] && <span className={dividerStyle} />}
        <span className={criteriaListElement}>{getRoomsMinLabel(t, criteria.rooms_min)}</span>
        <span className={dividerStyle} />
        <span className={criteriaListElement}>
          {`${t('main-search:SearchSettings_Price_Intro')} ${getBudgetFromCriteria(lang, criteria.budget)}`}
        </span>
      </Description>
    </>
  )
}
